
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fushiji/faq",
      function () {
        return require("private-next-pages/fushiji/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fushiji/faq"])
      });
    }
  